import type { IIndication } from '../../../../../../common/utils/ggzoEmblIndicationUtils';
import { getGroupedIndications } from '../../../../../../common/utils/ggzoEmblIndicationUtils';
import { FormDivider, FormSubHeader } from '../../../../elements/common';
import { IndicationsForType } from './IndicationsForType';

interface IIndicationsProps {
    indications: IIndication[] | undefined;
}

export function Indications(props: IIndicationsProps) {
    const groupedIndications = getGroupedIndications(props.indications);

    if (groupedIndications.length === 0) {
        return null;
    }

    return (
        <>
            <FormDivider />
            <FormSubHeader>Indicaties</FormSubHeader>

            {groupedIndications.map((groupedIndication) => (
                <IndicationsForType
                    {...groupedIndication}
                    key={groupedIndication.label}
                />
            ))}
        </>
    );
}
